
import { mapState } from "vuex";
import moment from "moment";
export default {
  name: "ReportHeaderDateRangeOptions",
  data: () => ({
    MAX_RANGE: 7,
    selectedTime: "",
    fromTime: "",
    fromDate: "",
    toTime: "",
    toDate: "",
    fromTimeMenu: false,
    fromDateMenu: false,
    toTimeMenu: false,
    toDateMenu: false,
    DAY_START_TIME: " 00:00",
    DAY_END_TIME: " 23:59:59"
  }),
  props: {
    timeList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState("report", [
      "sortOrder",
      "selectedTimeRange",
      "reportLoading",
      "selectedStartDate",
      "selectedEndDate"
    ]),
    now() {
      return moment(new Date()).format("YYYY-MM-DD HH:mm");
    },
    isValid() {
      return this.selectedTime === "custom"
        ? this.fromTime && this.fromDate && this.toTime && this.toDate
        : true;
    }
  },
  watch: {
    selectedTime(val) {
      if (val === "custom") {
        this.fromTime = this.DAY_START_TIME.trim();
        this.toTime = this.DAY_END_TIME.trim();
        this.fromDate = this.selectedStartDate
          ? moment(this.selectedStartDate).format("YYYY-MM-DD")
          : moment(new Date()).format("YYYY-MM-DD");
        this.toDate = this.selectedEndDate
          ? moment(this.selectedEndDate).format("YYYY-MM-DD")
          : moment(new Date()).format("YYYY-MM-DD");
      }
    },
    fromDate(val) {
      if (this.selectedTime === "custom") {
        const diff = this.getDateDifferenceInDays(this.fromDate, this.toDate);
        if (diff < 0) {
          this.toDate = val;
        } else if (diff >= this.MAX_RANGE) {
          let date = new Date(val);
          date.setDate(date.getDate() + this.MAX_RANGE - 1);
          this.toDate = date.toISOString().substring(0, 10);
        }
      }
    },
    toDate(val) {
      if (this.selectedTime === "custom") {
        const diff = this.getDateDifferenceInDays(this.fromDate, this.toDate);
        if (diff < 0) {
          this.fromDate = val;
        } else if (diff >= this.MAX_RANGE) {
          let date = new Date(val);
          date.setDate(date.getDate() - this.MAX_RANGE + 1);
          this.fromDate = date.toISOString().substring(0, 10);
        }
      }
    }
  },
  mounted() {
    this.selectedTime = this.selectedTimeRange || "today";
  },
  methods: {
    fromDateRange(val) {
      const date = new Date();
      return (
        val <= date.toISOString().substr(0, 10) &&
        val >
          new Date(date.setDate(date.getDate() - 7)).toISOString().substr(0, 10)
      );
    },
    toDateRange(val) {
      const date = new Date();
      return this.fromDateRange(val) && val >= this.fromTime;
    },
    dateRangeChange(force) {
      const payload = {
        force,
        selectedTime: this.selectedTime,
        closeMenu: true
      };
      if (this.selectedTime === "custom") {
        payload["customDateConfig"] = {
          fromDate: this.fromDate,
          fromTime: this.fromTime,
          toDate: this.toDate,
          toTime: this.toTime
        };
      }
      this.$emit("set-date-range", payload);
    }
  }
};
